// @ts-check

const scrollOffset = 148;

/**
 * @typedef {object} ObjectWithRefProperty
 * @property {React.RefObject<Element>} ref
 */

/**
 * Method for use with the find function that will return true for the first element in the array
 * whose bottom coordinate is above the threshold and therefore visible on the page
 * @param {ObjectWithRefProperty} refObject
 * @returns {boolean}
 */
export const findFirstElementInViewport = ({ ref }) => {
  if (!ref.current) return false;

  const { bottom } = ref.current.getBoundingClientRect();

  // Relies on the array being ordered from top to bottom
  return bottom >= scrollOffset;
};

/**
 * @param {React.RefObject<Element>} ref
 */
export const scrollToElement =
  (ref: React.RefObject<Element>, behavior: ScrollBehavior = 'smooth') =>
  () => {
    if (!ref.current) return;

    const { top } = ref.current.getBoundingClientRect();

    window.scrollBy({
      top: top - scrollOffset,
      behavior,
    });
  };
